
export const formatMoneyWithThousandSeparator = (value) => {
    if (!value || !value.toFixed) {
        value = 0
    }
    value /= 100
    value = value.toFixed(2) + ' €'
    value = value.replace('.', ',')
    let n = value.toString()
    while (true) {
        const n2 = n.replace(/(\d)(\d{3})($|,|\.)/g, '$1.$2$3')
        if (n === n2) {
            break
        }
        n = n2
    }
    return n
}



// WEBPACK FOOTER //
// ./src/modules/analytics/state/basis/helper.js